
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.745 8.313L9 5.568l2.745 2.745zM9 5.568L6.255 8.313 9 5.568zm0 0v6.863-6.863z","fill":"#5B5BE7"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9 1.53a7.47 7.47 0 100 14.94A7.47 7.47 0 009 1.53zm-5-.013a9 9 0 1110 14.966A9 9 0 014 1.517zm5 3.287c.203 0 .397.08.54.224l2.746 2.745a.765.765 0 11-1.082 1.081l-1.44-1.44v5.017a.765.765 0 01-1.529 0V7.414l-1.44 1.44a.765.765 0 11-1.08-1.081l2.744-2.745A.765.765 0 019 4.804z","fill":"#5B5BE7"}})])
          )
        }
      }
    